const toNucFieldsMap = {
  udprn: 'id',
  houseName: 'houseNameNumber',
  displayName: 'label'
};

const fromNucFieldsMap = Object.entries(toNucFieldsMap).reduce(
  (acc, [key, val]) => {
    return {
      ...acc,
      [val]: key
    };
  },
  {}
);

const convert = (address, map) => {
  return (
    address &&
    Object.entries(address).reduce((acc, [key, val]) => {
      const newKey = Object.keys(map).includes(key) ? map[key] : key;

      return {
        ...acc,
        [newKey]: val
      };
    }, {})
  );
};

export const toNucleusAddress = (address = {}) => {
  return convert(address, toNucFieldsMap);
};

export const fromNucleusAddress = (address = {}) => {
  return convert(address, fromNucFieldsMap);
};
